module.exports = __webpack_public_path__ + "img/section21.5c2c4cb7.png";